<ng-container *ngIf="!isLoading; else shimmer">
  <div class="category-container" *ngIf="cardCollection">
    <div
      class="collection-header"
      *ngIf="
        (cardCollection.name || cardCollection.description) &&
        ([
          customCardCategories.challenges,
          customCardCategories.discover,
          customCardCategories.recommended,
          customCardCategories.resources
        ].includes(customCardCategory) ||
          cardDisplayType === cardDisplayTypes.checklist)
      ">
      <div
        class="collection-information"
        *ngIf="
          !noCards ||
          (customCardCategory === customCardCategories.takeAction && cardCollection.name && collectionIndex === 0)
        ">
        <h3 class="collection-title" *ngIf="cardCollection.name">
          <span>{{ cardCollection.name }}</span>
        </h3>
        <h3 class="collection-description" *ngIf="cardCollection.description">{{ cardCollection.description }}</h3>
      </div>
    </div>
    <div
      class="title-link title-action-reminders"
      *ngIf="[customCardCategories.reminders].includes(customCardCategory)">
      <span>
        <svg-icon class="title-icon category-icon" [src]="cardCategoryIcon"></svg-icon>
        {{ cardCollection.name }}
      </span>
      <p class="category-description">{{ cardCollection.description }}</p>
    </div>
    <div
      class="main-card-container"
      [ngClass]="{ 'no-cards': noCards && ![customCardCategories.takeAction].includes(customCardCategory) }">
      <ng-container *ngIf="!isSearch">
        <ng-container
          *ngIf="
            [
              customCardCategories.challenges,
              customCardCategories.discover,
              customCardCategories.resources,
              customCardCategories.recommended
            ].includes(customCardCategory)
          ">
          <ng-container *ngIf="!noCards; else noCardsMessage">
            <!-- add bang -->
            <ng-container *ngIf="showLeftArrow">
              <svg-icon
                class="button-card-category button-left"
                src="/assets/icons/chevron-left-nocircle.svg"
                (click)="moveLeft()"></svg-icon>
            </ng-container>
            <drag-scroll
              #ds
              (reachesLeftBound)="leftBoundStat($event)"
              (reachesRightBound)="rightBoundStat($event)"
              [scrollbar-hidden]="true"
              [drag-scroll-y-disabled]="true">
              <kp-card
                *ngIf="allCompleted"
                [allCompleted]="true"
                [customCardCategory]="customCardCategory"
                [cardDisplayType]="cardDisplayType"
                [requestType]="requestType"
                drag-scroll-item></kp-card>
              <kp-card
                *ngFor="let card of collectionCards; let i = index"
                drag-scroll-item
                [cardId]="card.id"
                [screen]="screen"
                [customCardCategory]="customCardCategory"
                [cardDisplayType]="cardDisplayType"
                [requestType]="requestType"
                snInViewport
                (inViewportChange)="onInViewportChange($event, card, i)"></kp-card>
            </drag-scroll>
            <ng-container *ngIf="showRightArrow">
              <svg-icon
                class="button-card-category button-right"
                src="/assets/icons/chevron-right-nocircle.svg"
                (click)="moveRight()"></svg-icon>
            </ng-container>
          </ng-container>
          <ng-template #noCardsMessage>
            <div class="no-cards-container">
              <p class="starter-text">
                Here you'll track purposeful
                {{ customCardCategory === customCardCategories.actions ? 'habits and actions' : 'quests' }} you've
                committed to.
              </p>
              <p class="second-starter-text">
                Go to
                <!--Added ng-container here due to prettier adding extra space in <a> tag-->
                <ng-container *ngIf="customCardCategory === customCardCategories.actions">
                  <a routerLink="/discover" [queryParams]="{ resetSearch: true }">Discover</a>
                </ng-container>
                <ng-container *ngIf="customCardCategory === customCardCategories.quests">
                  <a routerLink="/discover" [queryParams]="{ searchTerm: 'Quest' }">Discover</a>
                </ng-container>
                to find a few things you'd like to try!
              </p>
            </div>
          </ng-template>
        </ng-container>

        <ng-container *ngIf="[customCardCategories.saved].includes(customCardCategory)">
          <div class="custom-category">
            <kp-card
              *ngIf="allCompleted"
              [allCompleted]="true"
              [customCardCategory]="customCardCategory"
              [cardDisplayType]="cardDisplayType"
              [requestType]="requestType"></kp-card>
            <kp-card
              *ngFor="let card of collectionCards; let i = index"
              [customCardCategory]="customCardCategory"
              [cardDisplayType]="cardDisplayType"
              [cardId]="card.id"
              snInViewport
              [screen]="screen"
              [requestType]="requestType"></kp-card>
          </div>
        </ng-container>

        <ng-container *ngIf="[customCardCategories.reminders].includes(customCardCategory)">
          <div class="custom-category action-reminder-category">
            <kp-card
              *ngIf="noReminders"
              [noReminders]="true"
              [screen]="screen"
              [customCardCategory]="customCardCategory"
              [cardDisplayType]="cardDisplayType"
              [requestType]="requestType"></kp-card>
            <ng-container *ngFor="let card of collectionCards; let i = index">
              <kp-card
                *ngIf="!card.userState.isCompleted && card.userState?.notifications?.length > 0"
                [cardId]="card.id"
                [customCardCategory]="customCardCategory"
                [cardDisplayType]="cardDisplayType"
                snInViewport
                [screen]="screen"
                [requestType]="requestType"></kp-card>
            </ng-container>
          </div>
        </ng-container>

        <ng-container *ngIf="[customCardCategories.takeAction].includes(customCardCategory)">
          <div class="custom-category take-action-category" *ngIf="!noCards">
            <ng-container *ngFor="let card of collectionCards; let i = index">
              <kp-card
                [cardId]="card.id"
                [customCardCategory]="customCardCategory"
                [cardDisplayType]="cardDisplayType"
                snInViewport
                [screen]="screen"
                [requestType]="cardRequestType.TRACKING"></kp-card>
            </ng-container>
          </div>
          <div
            class="custom-category take-action-category no-focus no-cards-container"
            *ngIf="noCards && cardCollection.name && collectionIndex === 0">
            <!-- NOTE: this is based on the assumption that in take action, only focus sends the name but no cards (empty array) -->
            <p class="no-focus-teaser">
              Here you'll track Quests and Actions you've committed to. Go to
              <a routerLink="/discover" [queryParams]="{ resetSearch: true }">Discover</a>
              to find things you'd like to try!
            </p>
          </div>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="isSearch">
        <div
          class="search"
          [ngClass]="{
            'search-resources': screen === cardScreen.resources || hasLocalResources
          }">
          <kp-card
            *ngFor="let card of collectionCards; let i = index; trackBy: trackByCard"
            [cardId]="card.id"
            [customCardCategory]="customCardCategory"
            [cardDisplayType]="cardDisplayType"
            [screen]="screen"
            snInViewport
            (inViewportChange)="onInViewportChange($event, card, i)"
            [requestType]="requestType"></kp-card>
        </div>
      </ng-container>
    </div>
  </div>
</ng-container>

<ng-template #shimmer>
  <div
    class="category-container"
    *ngIf="
      [customCardCategories.challenges, customCardCategories.discover, customCardCategories.resources].includes(
        customCardCategory
      )
    ">
    <kp-shimmer class="shim-name"></kp-shimmer>
    <kp-shimmer class="shim-description"></kp-shimmer>
    <div class="main-card-container">
      <drag-scroll [drag-scroll-y-disabled]="true">
        <kp-shimmer class="shimmer-card" drag-scroll-item></kp-shimmer>
        <kp-shimmer class="shimmer-card" drag-scroll-item></kp-shimmer>
        <kp-shimmer class="shimmer-card" drag-scroll-item></kp-shimmer>
        <kp-shimmer class="shimmer-card" drag-scroll-item></kp-shimmer>
      </drag-scroll>
    </div>
    <kp-shimmer class="shim-name"></kp-shimmer>
    <kp-shimmer class="shim-description"></kp-shimmer>
    <div class="main-card-container">
      <drag-scroll [drag-scroll-y-disabled]="true">
        <kp-shimmer class="shimmer-card" drag-scroll-item></kp-shimmer>
        <kp-shimmer class="shimmer-card" drag-scroll-item></kp-shimmer>
        <kp-shimmer class="shimmer-card" drag-scroll-item></kp-shimmer>
        <kp-shimmer class="shimmer-card" drag-scroll-item></kp-shimmer>
      </drag-scroll>
    </div>
    <kp-shimmer class="shim-name"></kp-shimmer>
    <kp-shimmer class="shim-description"></kp-shimmer>
    <div class="main-card-container">
      <drag-scroll [drag-scroll-y-disabled]="true">
        <kp-shimmer class="shimmer-card" drag-scroll-item></kp-shimmer>
        <kp-shimmer class="shimmer-card" drag-scroll-item></kp-shimmer>
        <kp-shimmer class="shimmer-card" drag-scroll-item></kp-shimmer>
        <kp-shimmer class="shimmer-card" drag-scroll-item></kp-shimmer>
      </drag-scroll>
    </div>
  </div>
  <div
    class="category-container"
    *ngIf="[customCardCategories.saved].includes(customCardCategory) || screen === cardScreen.category">
    <div class="card-block card-block-shimmer no-header">
      <kp-shimmer class="shimmer-card"></kp-shimmer>
      <kp-shimmer class="shimmer-card"></kp-shimmer>
      <kp-shimmer class="shimmer-card"></kp-shimmer>
      <kp-shimmer class="shimmer-card"></kp-shimmer>
      <kp-shimmer class="shimmer-card"></kp-shimmer>
      <kp-shimmer class="shimmer-card"></kp-shimmer>
      <kp-shimmer class="shimmer-card"></kp-shimmer>
      <kp-shimmer class="shimmer-card"></kp-shimmer>
      <kp-shimmer class="shimmer-card"></kp-shimmer>
    </div>
  </div>
  <div
    class="category-container"
    *ngIf="[customCardCategories.takeAction, customCardCategories.reminders].includes(customCardCategory)">
    <div class="card-block card-block-shimmer no-header">
      <kp-shimmer class="shimmer-card mini-card"></kp-shimmer>
      <kp-shimmer class="shimmer-card mini-card"></kp-shimmer>
      <kp-shimmer class="shimmer-card mini-card"></kp-shimmer>
      <kp-shimmer class="shimmer-card mini-card"></kp-shimmer>
      <kp-shimmer class="shimmer-card mini-card"></kp-shimmer>
      <kp-shimmer class="shimmer-card mini-card"></kp-shimmer>
      <kp-shimmer class="shimmer-card mini-card"></kp-shimmer>
      <kp-shimmer class="shimmer-card mini-card"></kp-shimmer>
      <kp-shimmer class="shimmer-card mini-card"></kp-shimmer>
    </div>
  </div>
  <div
    class="category-container"
    *ngIf="
      ![
        customCardCategories.challenges,
        customCardCategories.discover,
        customCardCategories.recommended,
        customCardCategories.reminders,
        customCardCategories.resources,
        customCardCategories.saved,
        customCardCategories.takeAction
      ].includes(customCardCategory) && screen !== cardScreen.category
    ">
    <kp-shimmer class="shim-name"></kp-shimmer>
    <div class="main-card-container">
      <drag-scroll [drag-scroll-y-disabled]="true">
        <kp-shimmer class="shimmer-card" drag-scroll-item></kp-shimmer>
        <kp-shimmer class="shimmer-card" drag-scroll-item></kp-shimmer>
        <kp-shimmer class="shimmer-card" drag-scroll-item></kp-shimmer>
        <kp-shimmer class="shimmer-card" drag-scroll-item></kp-shimmer>
      </drag-scroll>
    </div>
  </div>
</ng-template>
